import React from "react";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";
import Link from "gatsby-link";
import "./PageLayout.css";
import "../css/reset.css";
import "../css/loader.css";
import { BarLoader } from "react-spinners";
import Header from "../components/TopNavigationBar";
import SidebarMobile from "../components/SidebarMobile";
import "../css/main.css";
import Address from "../components/Address";
import Modal from "../components/Modal";
import { Button } from "react-bootstrap";
import { validationForEmail } from "../js/regex";
import axios from "axios";
import { Provider } from "react-redux";
import createStore from "../state/createStore";
const store = createStore();
const WSLogo =
  "https://winpeforum.com/assets/elements/website-sketchers.png";
const LOGO = "https://winpeforum.com/assets/elements/winpe_new_logo2.png";

export class PageLayout extends React.Component {
  constructor(agrs) {
    super(agrs);
    this.state = {
      isLoading: true,
      isShowSidebar: false,
      activeRouteName: "",
      show: true,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isLoading: !this.state.isLoading,
      });
    }, 100);
  }
  toggleSidebar = () => {
    this.setState({
      isShowSidebar: !this.state.isShowSidebar,
    });
  };
  toggleModal = () => {
    this.setState({
      show: !this.state.show,
    });
  };
  handleEmail = (e) => {
    e.preventDefault();
    this.setState({
      subscriberEmail: e.target.value,
    });
  };
  submitEmail = () => {
    if (validationForEmail(this.state.subscriberEmail)) {
      // console.log("submit")
      this.setState({
        emailError: false,
        isSubmittingEmail: true,
      });
      let emailParams = `email=${this.state.subscriberEmail}`;
      axios
        .get(
          `https://blackelephantdigital.in/blackele/sunny/api/winpe-api/public/newsletter_subscriber?${emailParams}`
        )
        .then((response) => {
          let { data } = response;
          if (data === "Success") {
            this.setState({
              isSubmitted: true,
              isSubmittingEmail: false,
            });
          } else {
            this.setState({
              emailError: "This email is already subcribed",
              isSubmittingEmail: false,
            });
          }
        });
    } else {
      this.setState({
        emailError: "Please enter a valid email address",
      });
    }
  };
  render() {
    const { children, location } = this.props;
    const {
      isShowSidebar,
      isLoading,
      emailError,
      isSubmitted,
      show,
      isSubmittingEmail,
    } = this.state;
    let route = location.pathname.split("/")[1];
    const appChildren =
      process.env.NODE_ENV === "production"
        ? children({ location })
        : children();
    let activeRoute = location.hash;
    return (
      <Provider store={store}>
        <div className="page-layout__viewport">
          {isLoading ? (
            <div className="loader__class">
              <BarLoader color={"#22316B"} loading={isLoading} />
            </div>
          ) : null}
          <div className="page-layout__viewport__header">
            <div className="menu__bar">
              <MediaQuery query="(min-width: 1230px)">
                <div className="new_header_section">
                  <div className="left_header_section">
                    <div className="h_logo">
                      <Link to="/home/" className="">
                        <img
                          src="https://winpeforum.com/assets/elements/winpe_new_logo2.png"
                          alt="Winpe"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="right_header_section">
                    <span className="dropdown blog">
                      <Link to="/home#about">about</Link>
                      <div className="dropdown-content">
                        <div className="row">
                          <div className="col-md-12">
                            <Link className="" to="/home#vision">
                              <div className="t_n">Vision</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/home#team">
                              <div className="t_n">People</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/press/">
                              <div className="t_n">press</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/winpecharter/">
                              <div className="t_n">Charter</div>
                            </Link>{" "}
                          </div>
                        </div>
                      </div>
                    </span>
                    <span className="dropdown blog">
                      <Link to="/home#initiatives">initiatives</Link>
                      <div className="dropdown-content">
                        <div className="row">
                          <div className="col-md-12">
                            <Link to="/events/">
                              <div className="t_n">events</div>
                            </Link>
                          </div>
                          <div className="col-md-12">
                            <Link to="/testimonials/">
                              <div className="t_n">testimonials</div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span className="dropdown1 blog">
                      <Link to="/insights/">insights</Link>
                      <div className="dropdown-content">
                        <div className="row">
                          {/*
												<div className="col-md-12"><Link to="/insights/superpowerofand"><div className="t_n">Kirthiga Reddy of SoftBank Investment Advisers</div></Link></div>
												<div className="col-md-12"><Link to="/insights/inclusiveleadership"><div className="t_n">Inclusive Leadership: The Next Normal</div></Link></div>
												<div className="col-md-12"><Link to="/insights/navigatingfundraising"><div className="t_n">Lizzie chapman of ZestMoney</div></Link></div>
												<div className="col-md-12"><Link to="/insights/diversityatrisk"><div className="t_n">Diversity at Risk: The Next Normal</div></Link></div>
												<div className="col-md-12"><Link to="/insights/holdingmyown"><div className="t_n">Manisha Girotra of Moelis & Company</div></Link></div>
												<div className="col-md-12"><Link to="/insights/reimaginingtheworkplace"><div className="t_n">Reimagining the Workplace: The Next Normal</div></Link></div>
												<div className="col-md-12"><Link to="/insights/padmajaruparelofindianangelnetwork"><div className="t_n">Padmaja Ruparel of Indian Angel Network</div></Link></div>
												<div className="col-md-12"><Link to="/insights/changingtimesadfiperspective"><div className="t_n">Alagappan Murugappan of CDC Group</div></Link></div>
												<div className="col-md-12"><Link to="/insights/shwetajalanofadventinternational"><div className="t_n">Shweta Jalan of Advent International</div></Link></div>
												<div className="col-md-12"><Link to="/insights/thestockdaleparadox"><div className="t_n">Bala C Deshpande of MegaDelta Capital</div></Link></div>
												<div className="col-md-12"><Link to="/insights/myLPmusings"><div className="t_n">Nupur Garg of Winpe Forum</div></Link></div>
												<div className="col-md-12"><Link to="/insights/celebratingwomenininvesting"><div className="t_n">Celebrating Women in Investing</div></Link></div>
												*/}
                        </div>
                      </div>
                    </span>
                    <span className="dropdown2 blog">
                      <Link to="/home#partners">partners</Link>
                      {/* <div className="dropdown-content">
											<div className="row">
												<div className="col-md-12"><Link className="" to="/home#winpemanifesto" ><div className="t_n">partner Manifesto</div></Link> </div>
											</div>
										</div> */}
                    </span>
                    <span className="dropdown blog">
                      <Link to="/knowledgeresources/">knowledge center</Link>
                    </span>
                    <span className="dropdown blog">
                      <Link to="/connect/">connect</Link>
                    </span>
                  </div>
                  <div className="new_desTop_sm">
                    <div className="social_icons_top">
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.facebook.com/winpeforum/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://twitter.com/winpeforum"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-twitter"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.linkedin.com/company/winpeforum"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-linkedin"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/WinPEforum/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.youtube.com/@winpeforum791"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-youtube"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://winpeinsights.medium.com/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-medium" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.winpeforum.com/whatsappgroups/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-whatsapp"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </MediaQuery>
              <MediaQuery query="(max-width: 1230px)">
                <span>
                  <span className="logo">
                    <Link to="/">
                      <img
                        src={LOGO}
                        alt="Winpe"
                        className="mobile__logo"
                      />
                    </Link>
                  </span>
                  <span className="hmb pull-right" onClick={this.toggleSidebar}>
                    <i className="fa fa-bars" />
                  </span>
                  <SidebarMobile
                    show={isShowSidebar}
                    onHide={this.toggleSidebar}
                    activePathname={activeRoute}
                  />
                </span>
              </MediaQuery>
            </div>
          </div>
          {/*
				<MediaQuery query="(min-width: 1025px)">
					<div className="page-layout__viewport__left_content">
						<div className="social_icons">
							<div className="icon">
								<a rel="noopener noreferrer" href="https://www.facebook.com/winpeforum/" target="_blank" className=""><i className="fa fa-facebook"></i></a>
							</div>
							<div className="icon">
								<a rel="noopener noreferrer" href="https://twitter.com/winpeforum" target="_blank" className=""><i className="fa fa-twitter"></i></a>
							</div>
							<div className="icon">
								<a rel="noopener noreferrer" href="https://www.linkedin.com/company/winpeforum" target="_blank" className=""><i className="fa fa-linkedin"></i></a>
							</div>
							<div className="icon">
								<a rel="noopener noreferrer" href="https://www.instagram.com/WinPEforum/" target="_blank" className=""><i className="fa fa-instagram"></i></a>
							</div>
							<div className="icon">
								<a rel="noopener noreferrer" href="https://www.youtube.com/watch?v=q-bE10X9KcA&t=2s" target="_blank" className=""><i className="fa fa-youtube"></i></a>
							</div>
						</div>
					</div>
				</MediaQuery>
				*/}
          <div className="background__wrapper">
            <div className="background__texture" />
          </div>
          {appChildren}
          <div className="page-layout__viewport__footer_content">
            <div>
              <MediaQuery query="(min-width:1001px)">
                <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div className="left__content">
                      © Winpe 2021. All Rights Reserved. <a style={{color:'#fff', textDecoration: 'underline'}} href="https://winpeforum.com/terms-of-use/">Winpe App: Terms of Use</a>.<a style={{color:'#fff', textDecoration: 'underline'}} href="https://winpeforum.com/PrivacyPolicy/">Privacy Policy</a>.
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="middle__content">
                      <Address />
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="right__content">
                      Powered By{" "}
                      <a
                        href="https://websitesketchers.com"
                        rel="noopener noreferrer"
                        target="_blank"
                        className=""
                        style={{color:"#ffffff"}}
                      >
                       Website Sketchers
                      </a>
                    </div>
                  </div>
                </div>
              </MediaQuery>
            </div>
            <div>
              <MediaQuery query="(max-width:1000px)">
                <div className="row">
                  <div className="m_add">
                    <Address />
                  </div>
                  <div className="col-sm-12 col-xs-12">
                    <div className="left__content">
                      © Winpe 2021. All Rights Reserved. <a style={{color:'#fff', textDecoration: 'underline'}} href="https://winpeforum.com/terms-of-use/">Terms of Use</a>.<a style={{color:'#fff', textDecoration: 'underline'}} href="https://winpeforum.com/PrivacyPolicy/">Privacy Policy</a>.
                    </div>
                  </div>
                  <div className="col-sm-12 col-xs-12">
                    <div className="middle__content"></div>
                  </div>
                  <div className="col-sm-12 col-xs-12">
                    <div className="right__content" >
                      Powered By{" "}
                      <a
                        href="https://websitesketchers.com"
                        rel="noopener noreferrer"
                        target="_blank"
                        className=""
                        style={{color:"#ffffff"}}
                      >
                       Website Sketchers
                      </a>
                    </div>
                  </div>
                </div>
              </MediaQuery>
            </div>
          </div>
          {/*
				<MediaQuery query="(max-width:1024px)">
					<Modal show={show && (route === "")} className="newsletter__pop_up" onHide={this.toggleModal}>
						<Modal.Header>
							<span className="cross__icon" onClick={this.toggleModal}>
								<i className="fa fa-times" />
							</span>
						</Modal.Header>
						<Modal.Body>
							<div className="__modal">
								{isSubmitted
									? <div className="__modal_inner_box">
										<h3>Thank you for Signing up for updated from WinPE. An email has been sent to your address for verification and confirmation.</h3>
									</div>
									: <div className="__modal_inner_box">
										<div className="__modal__text">
											SUBSCRIBE TO UPDATES
										</div>
										<form action={this.submitEmail}>
											<input type="email" onChange={(e) => this.handleEmail(e)} className="form-control" placeholder="Enter Email" />
										</form>
										<div className="email-error"><small>{emailError}</small></div>
										<Button type="submit" onClick={isSubmittingEmail ? () => {} : this.submitEmail} className="btn">{isSubmittingEmail ? <span>Submitting <i className="fa fa-spin fa-spinner"></i></span> : "SUBMIT"}</Button>
										<div className="btm_text">
										</div>
										<div className="btm_text1">
											You can also sign up later using the Connect form.
										</div>
									</div>}
							</div>
						</Modal.Body>
					</Modal>
				</MediaQuery>
				*/}
        </div>
      </Provider>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.func,
  location: PropTypes.object,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.js